/*
type常量
*/

// 設置頭部標題
export const SET_HEAD_TITLE = 'set_head_title' 
// 接收用戶資訊
export const RECERVE_USER = 'receive_user'
// 重置用戶資訊
export const RESET_USER = 'reset_user'
// 顯示錯誤訊息
export const SHOW_ERROR_MSG = 'show_error_msg'

